import React, { useEffect } from 'react'
import { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';

import LoadingComponent from '../../../../components/Loading';

import { useSelector } from "react-redux";
import { Box, IconButton, TextField, Typography } from '@material-ui/core';

import {
    selectUsuarioSeleccionado,
} from "../../../../redux/reducer/loginReducer";
import 'react-pivottable/pivottable.css';
import TituloPagina from '../../../../components/Titulos/TituloPagina';
import { getFacturas } from '../../../../services/cuotas';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';

import Moment from 'react-moment';
import { DataGrid, GridActionsCellItem, GridToolbarDensitySelector, GridToolbarFilterButton} from '@mui/x-data-grid';
import DataGridInnovattio from '../../../../components/DataGridInnovatiio';
import useDataGridFilterPersist from '../../../../hooks/useDataGridFilterPersist';

import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '80px'
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh"
    },
    emptyContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        width: '100%',
        flexDirection: 'column',
        textAlign: 'center'
    },
    emptyImage: {
        width: '100%'
    },
    rootFilter: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      },
    textFieldFilter: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
        margin: theme.spacing(1, 0.5, 1.5),
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(0.5),
        },
        '& .MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    enlace: {
      color: theme.palette.link.main,
      textDecoration: 'none'
    }
}));

export default function VerifactuContent() {
    const classes = useStyles();
    const [selectionModel, setSelectionModel] = React.useState([]);

    // // const [facturas, setFacturas] = useState([]);
    const [loading, setLoading] = useState(false)
    const [loadingMensaje, setLoadingMensaje] = useState("")
    const [facturas, setFacturas] = useState([]);

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });

    useEffect(() => {
        setLoading(true)
        setLoadingMensaje("Cargando facturas")

        const usuario_id = usuarioSeleccionado.id

        getFacturas({ usuario_id }).then((response) => {

            response && setFacturas(response.facturas)
            setLoading(false)
        });

    }, [])
    /* -------------------------------------------------------------------------- */
    /*                           Definicion de columnas                           */
    /* -------------------------------------------------------------------------- */
    const columnas = [
        { field: 'id', hide: true, headerName: 'ID' },
        { field: 'num_serie_factura', headerName: 'Num factura', flex: 1 },
        { field: 'alumno_nombre', headerName: 'Alumno', flex: 1 },
        { field: 'alumno_dni', headerName: 'DNI', flex: 1 },
        { field: 'alumno_direccion', headerName: 'Direccion', flex: 1 },
        { field: 'alumno_codigo_postal', headerName: 'CP', flex: 1 },
        { field: 'alumno_ciudad', headerName: 'Ciudad', flex: 1 },
        { field: 'alumno_provincia', headerName: 'Provincia', flex: 1 },
        { field: 'alumno_pais', headerName: 'Pais', flex: 1 },
        { field: 'cuota_fecha_cobro', headerName: 'Cuota fecha', flex: 1 },
        { field: 'cuota_importe', headerName: 'total', flex: 1 },
        { field: 'verifactu_fecha', headerName: 'Cuota fecha', flex: 1 },
        // {
        //   'field': 'fecha', 
        //   'width':120, 
        //   'headerName': 'Fecha', 
        //   'description': 'Fecha',
        //   type: 'date',
        //   renderCell: (cellValues) => {
        //     return (
              
        //         (cellValues.value !== null && cellValues.value !== "0000-00-00 00:00:00") ?
        
        //         <Moment format="DD/MM/YYYY">
        //           {cellValues.value}
        //         </Moment>
        
        //         :
        
        //         <></>
        
              
        //     );
        //   } 
        // },
        {
          'field': 'pedido', 
          'width':80, 
          'headerName': 'Pedido', 
          'description': '',
          renderCell: (cellValues) => {
            return (
              <a href={`https://gestion.innovatiio.com/api/v1/alumno/factura?id=${cellValues.row.id}`} target="_blank">
                <PictureAsPdfIcon />
              </a>
            )
          }
        },
        {
          'field': 'verifactu_pdf', 
          'width':80, 
          'headerName': 'Verifactu', 
          'description': '',
          renderCell: (cellValues) => {
            return (
            <>
              {cellValues.row.verifactu_pdf && <a href={`https://gestion.innovatiio.com/api/uploads/facturas_verifactu/${cellValues.row.verifactu_pdf}`} target="_blank">
                <PictureAsPdfIcon />
              </a>}

              {!cellValues.row.verifactu_pdf && <span style={{color: 'red'}}>ERROR</span>}
              </>
            )
          }
        },
        {
          field: 'actions',
          type: 'actions',
          width: 50,
          getActions: (params) => [
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Actualizar datos alumno"
            //   onClick={() => facturaActualizarDatosAlumno(params)}
              // component={Link}
              // to={`alumnos/detalle/${params.id}`}
              showInMenu
            />,
            // <GridActionsCellItem
            //   icon={<DeleteIcon />}
            //   label="Eliminar"
            //   onClick={() => linkDelete(params.id)}
            //   showInMenu
            // />,
          ],
        }
    ];

    /* -------------------------------------------------------------------------- */
    /*                            Definición de Handler                           */
    /* -------------------------------------------------------------------------- */
    

    function QuickSearchToolbar(props) {
      const classes = useStyles();
    
      return (
        <div className={classes.rootFilter}>
          <div>
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
          </div>
          <TextField
            variant="standard"
            value={props.value}
            onChange={props.onChange}
            placeholder="Buscar…"
            className={classes.textFieldFilter}
            InputProps={{
              startAdornment: <SearchIcon fontSize="small" />,
              endAdornment: (
                <IconButton
                  title="Clear"
                  aria-label="Clear"
                  size="small"
                  style={{ visibility: props.value ? 'visible' : 'hidden' }}
                  onClick={props.clearSearch}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ),
            }}
          />
        </div>
      );
    }
    
    QuickSearchToolbar.propTypes = {
      clearSearch: PropTypes.func.isRequired,
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string.isRequired,
    };
    
    const Contenido = () => {
        const [filterModel, onFilterModelChange] = useDataGridFilterPersist('facturas_verifactu_page','facturas')
        
      const [rows, setRows] = React.useState(facturas);
      const [searchText, setSearchText] = React.useState('');
          const requestSearch = (searchValue) => {
            // console.log(searchValue)
            setSearchText(searchValue);
            const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
            // const searchRegex = new RegExp(`.*${searchValue}.*`, 'ig');
            const filteredRows = facturas.filter((row) => {
                return Object.keys(row).some((field) => {
                    // console.log(field)
                    // console.log(row)
                    return searchRegex.test(row[field]);
                });
            });
            setRows(filteredRows);
          };

        return (
                <>
                    <TituloPagina titulo={"Facturas"} />
                    
                    <div style={{ height: 500, width: '100%', padding:"0 15px" }}>
                        <DataGridInnovattio
                            rows={rows} 
                            columns={columnas} 
                            rowHeight={30}
                            components={{ Toolbar: QuickSearchToolbar }}
                            // onDoubleClick={ (evento ) => handleAlumnoDetalle(evento.id) }
                            filterModel={ filterModel }
                          onFilterModelChange={ onFilterModelChange }
                            // checkboxSelection={usuarioSeleccionado.perfil_id === '1'}
                            // onSelectionModelChange={(newSelectionModel) => {
                            //   setSelectionModel(newSelectionModel);
                            // }}
                            // selectionModel={selectionModel}
                            componentsProps={{
                                toolbar: {
                                  value: searchText,
                                  onChange: (event) => requestSearch(event.target.value),
                                  clearSearch: () => requestSearch(''),
                                },
                            }}
                            // filterModel={filterModel}
                            // onFilterModelChange={(model) => setFilterModel(model)}
                        />
                    </div>
                    
                    {/* <Typography variant='caption' style={{marginTop: 10, marginLeft: 16}}>NOTA: Ordenado por fecha de entrada de gasto decreciente</Typography> */}

                </>
                
        )
    }
    
    // /* -------------------------------------------------------------------------- */
    // /*                                   Return                                   */
    // /* -------------------------------------------------------------------------- */
    return (
        <div className={classes.container}>
            {
                (loading ?
                    
                    <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
                    
                    :
                    
                    <Contenido />
                )
            }
        </div>
    )
}
